import { Roles } from '@omnea-digital/toolbox'
import { useTranslation } from 'react-i18next'
import { getRoleLabelFromUserConfig } from '@omnea-app/fe-auth/roles'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import type { AvailableOrganisation } from '@omnea-app/login/loginFrontendClient'

/** The signed-in user's role in each organisation they can switch to, as the org switchers show it. */
export const useOrgRoleLabel = () => {
  const { t } = useTranslation('settings')
  // P2P_ADMIN_MODE: when the active org has the flag on, label Admins as "P2P User" across every
  // row in the switcher (intentionally including other orgs — we only read the active org's flag).
  const p2pAdminMode = useFeatureFlags().P2P_ADMIN_MODE

  return ({ user }: AvailableOrganisation) =>
    getRoleLabelFromUserConfig({
      t,
      userConfig: { role: user.role as Roles, hasConfigPermissions: user.hasConfigPermissions, isViewOnly: user.isViewOnly },
      p2pAdminMode,
    })
}
